import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { UploadOutlined } from '@ant-design/icons';
import { Button, message, Upload } from 'antd';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { Box, Flex } from 'atoms';
import { getSignedUrl, uploadFilesToS3 } from 'store/commonSlice';

const ActionAddButton = styled(Button)`
	background: #1890ff !important;
	color: #fff !important;
	border-radius: 4px;
	margin-top: 0px !important;
	margin-left: 5px;
`;

export default function FilesUploadS3({
	entity,
	key,
	setFunc,
	successCallBack,
	extraParams = null,
	name = '',
	size,
	fileformates = [],
	filetypetoShow,
}) {
	const [fileList, setFileList] = useState([]);
	const [uploading, setUploading] = useState(false);
	const [filetype, SetFileType] = useState('');
	const [fileUploadDisable, setFileUploadDisable] = useState('');
	const [filesUploaded, setFilesUploaded] = useState(false);
	// const [messageOnUpload, setMessageOnUpload] = useState(false);
	const dispatch = useDispatch();
	const mbsize = size / 1024 / 1000;
	console.log(mbsize);
	// console.log(successCallBack);
	// console.log(extraParams);

	// Helper function to get upload button text
	const getUploadButtonText = () => {
		if (uploading) return 'Uploading';
		if (filesUploaded) return 'Uploaded';
		return 'Upload ';
	};

	function hadleClick() {
		if (fileList.length > 0) {
			const keys = fileList?.map((item) => item?.name);
			const data = {
				url_type: 'upload',
				data: { entity, keys },
			};

			dispatch(getSignedUrl(data)).then((res) => {
				console.log(res);
				handleUpload(res?.data);
			});
		}
	}

	function onUploadComplete(urls) {
		console.log('extraParams', extraParams);
		const files = urls?.map((file) => file?.filename);
		let data = files;
		if (!isEmpty(extraParams)) {
			data = {
				files,
				extraParams,
			};
		}
		console.log('data', data);
		successCallBack(data, key, setFunc);
		// Mark files as uploaded to disable upload buttons
		setFilesUploaded(true);
	}

	const handleUpload = (urls) => {
		console.log(urls);
		urls?.forEach((item, index) => {
			console.log(item);
			console.log(fileList?.[index]);
			const formData = new FormData();
			formData.append(item.filename, fileList?.[index]?.originFileObj);
			console.log(fileList);
			setUploading(true);
			const data = {
				url: item?.url,
				data: fileList?.[index]?.originFileObj,
			};
			dispatch(uploadFilesToS3(data, filetype))
				.then((res) => {
					console.log('res', res);
				})
				.catch((e) => {
					console.log('e', e);
				})
				.finally(() => {
					setTimeout(() => {
						setUploading(false);
					}, 1000);
				});

			if (index === urls.length - 1) {
				setTimeout(() => {
					onUploadComplete(urls);
				}, 100);
				// setMessageOnUpload(true);
			}
		});
	};

	const props = {
		fileList,

		beforeUpload: (file) => {
			console.log(file);
			SetFileType(file.type);
			console.log(file.size);
			console.log(size);
			console.log(size < file.size);

			console.log(fileformates.includes(file.type));
			if (!fileformates.includes(file.type)) {
				message.error(`Invalid File format`);
			}
			if (file.size > size) {
				setFileUploadDisable(true);
				message.error(`File size is greater`);
				return false;
			}
			if (file.size <= size) {
				setFileUploadDisable(false);
				return false;
			}

			return false;
		},
		onChange: (info) => {
			setFileList(info.fileList);
			// If files are removed, re-enable upload buttons
			if (info.fileList.length === 0) {
				setFilesUploaded(false);
			}
		},
	};

	// const fileformates = ['application/pdf', 'image/png', 'image/gif', 'image/jpeg'];
	useEffect(() => {
		if (fileList.length > 0) {
			const truncatedFileList = fileList.map((file) => {
				if (file.name.length > 20) {
					const extension = file.name.split('.').pop();
					const truncatedName = `${file.name.substring(0, 17)}...${extension}`;
					return {
						...file,
						name: truncatedName,
					};
				}
				return file;
			});
			setFileList(truncatedFileList);
		}
	}, [fileList]);

	// Check if upload buttons should be disabled
	const shouldDisableUpload = fileUploadDisable || filesUploaded;

	return (
		<Box>
			<Box>
				<h1>{name} : </h1>
			</Box>
			<Box color="#1890ff" fontSize="16px">
				{' '}
				File Types : {filetypetoShow}{' '}
			</Box>
			<Box color="#1890ff" fontSize="16px">
				{' '}
				Max Size : {mbsize} MB{' '}
			</Box>
			{fileUploadDisable && <Box color="red"> FIle is greater than {mbsize} MB </Box>}
			{filesUploaded && (
				<Box color="#52c41a" fontSize="16px">
					{' '}
					Files uploaded successfully{' '}
				</Box>
			)}
			{/* {messageOnUpload && (
				<Box color="#be26d9" fontSize="16px">
					Files uploaded successfully
				</Box>
			)} */}

			<Box>
				<Flex>
					{/* {entity} */}
					<Upload
						{...props}
						listType="picture"
						maxCount={1}
						accept={fileformates}
						disabled={filesUploaded}
					>
						<Button type="button" icon={<UploadOutlined />} disabled={filesUploaded}>
							{filesUploaded ? 'File Uploaded' : `Choose ${name}`}
						</Button>
					</Upload>
					<ActionAddButton
						type="button"
						disabled={shouldDisableUpload}
						loading={uploading}
						onClick={hadleClick}
					>
						{getUploadButtonText()}
					</ActionAddButton>
				</Flex>
			</Box>
		</Box>
	);
}

FilesUploadS3.propTypes = {
	entity: PropTypes.string,
	key: PropTypes.string,
	successCallBack: PropTypes.func,
	setFunc: PropTypes.func,
	extraParams: PropTypes.any,
	name: PropTypes.string,
	size: PropTypes.number,
	fileformates: PropTypes.array,
	filetypetoShow: PropTypes.string,
};
